import React from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import NABTheme from './themes/nab';
import { StyledGlobalFont } from './Theme.style';
var themes = {
  nab: NABTheme
};
Theme.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(Object.keys(themes))
};
Theme.defaultProps = {
  children: '-',
  theme: 'nab'
};
export function Theme(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  var currentTheme = themes[theme];
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: currentTheme
  }, /*#__PURE__*/React.createElement(StyledGlobalFont, null, children));
}